import { CartModel } from '@/models/CartModel';
import { CheckoutModel } from '@/models/CheckoutModel';
import { Moment } from 'moment';

export interface CartState {
  cart: CartModel | null;
  checkout: CheckoutModel | null;
  pickupDateTime: Moment | null;
}

const state: CartState = {
  cart: null,
  checkout: null,
  pickupDateTime: null,
};

export default state;
